import { z } from "zod";

import {
  createMutationRequestDefinition,
  createQueryRequestDefinition,
} from "~/lib/network/definitions/create";

export const createFileUploadMutation = createMutationRequestDefinition({
  host: "web-core",
  method: "POST",
  path: "file/v3/upload",
  paramsSchema: z.object({
    filename: z.string(),
    extension: z.string(),
    mimeType: z.string(),
    size: z.number(),
  }),
  responseSchema: z.object({
    fileId: z.string(),
  }),
});

export const getUploadedFileInfoQuery = createQueryRequestDefinition({
  queryKey: ["get-file-info"],
  host: "web-core",
  method: "GET",
  path: "file/v3/upload/:fileId",
  // TODO: can we hard code into path?
  paramsSchema: z.object({ gcsUri: z.literal(true) }),
  responseSchema: z.object({
    fileId: z.string(),
    type: z.string(),
    status: z.enum(["UPLOADING", "READY", "DELETED", "ERROR"]),
    gcsUri: z.string(),
    url: z.string(),
  }),
}).withPolling({
  determinePollingStatus(response, resultCreator) {
    if (response.status === "READY") {
      return resultCreator.done(response);
    } else if (response.status === "ERROR") {
      return resultCreator.failed(response);
    }

    return resultCreator.pending(response);
  },
});

export const uploadFileChunkMutation = createMutationRequestDefinition({
  host: "file-upload",
  method: "POST",
  path: "file/v1/upload/:fileId",
  paramsSchema: z.instanceof(FormData),
  responseSchema: z.object({ lastByte: z.number() }),
});

export const backendAssetEnum = z.enum(["audio", "video", "image", "pag"]);
export type BackendAssetType = z.infer<typeof backendAssetEnum>;

export const createAssetMutation = createMutationRequestDefinition({
  host: "cap-srv",
  method: "POST",
  path: "assets/create-from-uri",
  paramsSchema: z.object({
    type: backendAssetEnum,
    // must start with gs://
    uri: z.string(),
  }),
  responseSchema: z.object({ id: z.string() }),
});
